import { render } from "./ProfileEditFormPanelNewTheme.vue?vue&type=template&id=2a005d92&scoped=true"
import script from "./ProfileEditFormPanelNewTheme.vue?vue&type=script&lang=js"
export * from "./ProfileEditFormPanelNewTheme.vue?vue&type=script&lang=js"

import "./ProfileEditFormPanelNewTheme.vue?vue&type=style&index=0&id=2a005d92&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a005d92"]])

export default __exports__